import { ReactNode } from 'react';
import { Dropdown, Label, Message, Table } from 'semantic-ui-react';
import { TaskExecutionInfoType } from '../../../../schemas/task.schemas';
import Pagination from '../../../pagination';
import { ActionOptionType } from '../utils';

type BaseTaskExecutionsTableProps<TShowActions extends boolean = false> = {
    executions: TaskExecutionInfoType[];
    showActions?: TShowActions;
    page: number;
    setPage: (page: number) => void;
    openExecution: (execution: TaskExecutionInfoType) => void;
    totalPages: number;
    additionalActions?: ReactNode[];
};

type ConditionalActionsProps<TShowActions extends boolean = false> = TShowActions extends true
    ? { actions: ActionOptionType<TaskExecutionInfoType>[] }
    : { actions?: never };

type TaskExecutionsTableProps<TShowActions extends boolean = false> = BaseTaskExecutionsTableProps<TShowActions> &
    ConditionalActionsProps<TShowActions>;

function TaskExecutionsTable<TShowActions extends boolean = false>({
    executions,
    showActions,
    actions = [],
    page,
    setPage,
    totalPages,
    additionalActions,
    openExecution,
}: TaskExecutionsTableProps<TShowActions>) {
    return (
        <>
            {executions.length ? (
                <>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Id</Table.HeaderCell>
                                <Table.HeaderCell>Entity Name</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                {showActions && <Table.HeaderCell collapsing></Table.HeaderCell>}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {executions.map((execution) => {
                                return (
                                    <Table.Row
                                        className="cursorPointer"
                                        key={execution.id}
                                        onClick={() => openExecution(execution)}
                                    >
                                        <Table.Cell>
                                            <Label>{execution.entityId}</Label>
                                        </Table.Cell>
                                        <Table.Cell>{execution.entityName}</Table.Cell>
                                        <Table.Cell>{execution.status}</Table.Cell>
                                        {showActions && !!actions.length && (
                                            <Table.Cell>
                                                <Dropdown
                                                    name="actions"
                                                    icon="ellipsis vertical"
                                                    options={actions.map((action) => ({
                                                        ...action,
                                                        onClick: () => action.onClick(execution),
                                                    }))}
                                                    trigger={<></>}
                                                />
                                            </Table.Cell>
                                        )}
                                    </Table.Row>
                                );
                            })}
                            <Table.Row></Table.Row>
                        </Table.Body>
                    </Table>
                </>
            ) : (
                <Message>There are currently no execution related to this task</Message>
            )}

            <div className="flex full-width">
                {!!executions.length && <Pagination page={page} totalPages={totalPages} setPage={setPage} />}
                {additionalActions && additionalActions}
            </div>
        </>
    );
}

export default TaskExecutionsTable;
